// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDwtj2eVOTbccctK1YXIqBj4DwlR0P7Aps",
  authDomain: "atlan-4e7d0.firebaseapp.com",
  projectId: "atlan-4e7d0",
  storageBucket: "atlan-4e7d0.firebasestorage.app",
  messagingSenderId: "530294422068",
  appId: "1:530294422068:web:f0705150fa55e5e314e861",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const str = getStorage(app);
